var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editable-text"},[(_vm.editing)?_c('div',[_c('el-input',_vm._b({attrs:{"value":_vm.value},on:{"input":(e) => _vm.$emit('input', e)}},'el-input',_vm.$attrs,false))],1):_c('div',[_c('i',{staticClass:"editable-text__icon far fa-edit",on:{"click":function($event){_vm.editing = true}}}),_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }